<template>
    <div style="background-color:#fff" >
       <mini_head_top> </mini_head_top>
      <van-row type="flex"  justify="space-between" style="margin: auto; margin-top: 10px; padding: auto; width: 100%;text-align: left">
        <van-row>
          <span style="margin-left: 5px; height:16px;width:10px;background:#eded13; display: inline-block"> </span>
          <span style="font-size:16px;  font-weight:700">安全考试</span>
        </van-row>
        <el-link style="margin-right: 10px;" type="warning" @click.native="goHome()">主页 <i class= "el-icon-s-home"> </i></el-link>
      </van-row >

      <div style="overflow: auto; background-color: ghostwhite;  height: calc(80vh - 40px) ">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">
          <!-- <van-cell
          v-for="item in noticeList" :key="item.id" 
          :value = "item.theme" @click="viewNoticeOne(item.id)" >
          </van-cell> -->
          <div  v-for = " (item,index) in examList" :key="item.id" style=" width: 99%;  margin:auto;margin-top: 10px; padding: 5px; background-color: #fff; font-size: 12px; text-align: left;">
            <div style=" padding:2px;text-align: right;">
              <!-- 未开始啥都不显示examState = 1 -->
              
              <!-- 已经开始 -->
              <el-tag  size="mini"   type="warning"
                v-if = "item.examState == 2 && item.usrState == 1 ">  
                已开考,可考试
              </el-tag>
              
              <el-tag size="mini" type="info"
                v-if = "item.examState == 3
                && item.usrState == 1 ">  
                已结束,未考试
              </el-tag>

              <el-tag size="mini" type="success"
                v-if = "item.examState == 2
                && item.usrState == 2  && !item.selfExamOver">  
                已开考,考试中
              </el-tag>
              
              <el-tag size="mini" type="danger"
                v-if = "item.examState == 2
                && item.usrState == 2  && item.selfExamOver">  
                考试中,已超时
              </el-tag>
              <el-tag size="mini" type="success"
                v-if = "
                  item.usrState == 3 ">  
                已完成考试
              </el-tag>
              
              <el-tag  size="mini"   type="success"
                v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 1 ">  
                合格
              </el-tag>
              <el-tag  size="mini"   type="danger"
                v-if = "item.examState > 1 && item.usrState == 3  &&  item.result == 0">  
                不合格
              </el-tag>

              
              <!-- 已经完成考试或者考试结束未参加考试 -->
              <!-- <el-tag   size="mini" type="primary"
                v-if = "item.usrState == 3 || (item.examState == 3 && item.usrState != 2 ) "
                  @click="seePaper(item.examId)">  
                查看试卷
              </el-tag> -->
              <span>|</span>
             
              <!-- 中断并且未超时，不计入考试截止时间-->
              <el-tag  type = "primary"  size="mini"
                v-if = "(item.usrState == 2
                &&!item.selfExamOver)"  @click="handleViewPaper(item.examId,null)">  
                继续答题
              </el-tag>
              <!-- 并且自己考试时间用完 -->
              <el-tag  @click="handleCommitPaper(item.examId)"  type = "warning" size="mini"
                v-if = "item.usrState == 2 && item.selfExamOver ">  
                交卷 
              </el-tag>  
              <el-tag @click="handleViewPaper(item.examId,null)"  
                size="mini" type = "primary"
                v-if = "item.examState == 2 && item.usrState == 1 "> 
                开始答题
              </el-tag>
              <el-tag size="mini" type="info" style="margin-left:5px"
                    v-if = "item.examState == 3
                    && item.usrState == 1 ">  
                    无考试记录
                  </el-tag>
              <el-dropdown v-else  @command="handleCommandExam">

                <el-tag size="mini" style="margin-left:5px;cursor: pointer;" class="el-dropdown-link">
                  考试记录<i class="el-icon-arrow-down el-icon--right"></i>
                </el-tag>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-if = "item.examCount == 1"  divided  :command=" {examId:item.examId,examCount:1, examMaxCount:item.examCount }" >
                    <i :style="item.result == 1 ? 'color: #67C23A;':''" :class="item.result == 1 ? 'el-icon-success':'el-icon-warning'">当前考试 </i>
                  </el-dropdown-item>
                  <el-dropdown-item v-else  divided v-for=" (ite,index) in item.examCount" :command="{examId:item.examId,examCount:ite, examMaxCount:item.examCount }" :key="index">
                    <i v-if = " ite == 1"  class="el-icon-warning"> 第1次考试 </i>
                    <i v-else-if = "ite < item.examCount && ite > 1  "  class="el-icon-warning">{{ ' 第' + (ite - 1) + '次重考'}} </i>
                    <i v-else :style="item.result == 1 ? 'color: #67C23A;':''" :class="item.result == 1 ? 'el-icon-success':'el-icon-warning'"> 当前考试</i>
                  </el-dropdown-item>
                  <!-- :disabled = "item.examState == 3" -->
                  <el-dropdown-item divided  :command="{examId:item.examId,examCount:0, examMaxCount:item.examCount }" v-if = "item.result == 0">
                    <i style="color: #c2433a;" class="el-icon-warning"  > 重考</i>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div>  
              <el-tag  style ="display:inline-block" v-if = "item.examState == 1"  effect="dark" size="mini" type="info">未开考</el-tag>
              <el-tag  style ="display:inline-block" v-else-if = "item.examState == 2"  effect="dark" size="mini" type="success">已开考</el-tag>
              <el-tag  style ="display:inline-block"  v-else effect="dark" size="mini" type="danger">已结束</el-tag>
              <span style ="display:inline-block;width: 60%; font-weight: 700;"> {{index  + 1 }}. {{item.examTheme }}</span> 
            </div>
            <div style="margin-top:2px; font-size: 8px;">
              <span style="margin-left:50px">发布时间:{{ item.beginTime }}</span>
            </div>
            <div style="margin-top:2px;font-size: 8px;">
              <span style="margin-left:50px">开始时间:{{ item.beginTime }}</span>      <span style="margin-left:50px">截止时间:{{item.endTime}}</span> 
            </div>
          </div>
        </van-list>
      </div>
  </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import mini_head_top from "@/mini_pages/mini_head_top"
    import logo from "@/assets/image/yuanhui.png"
    import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_exa_list',
      data () {
        return {
          logo,
          theme:'',
          pageNo :0,
          totalPageSize : 0,
          type : "主题",
          examList: [],
          loading: false,
          finished: false
        }
      },
      methods: {
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        seePaper(id){
          this.$router.push( {path: '/mini_paper', query: { id: id}})
        },
        handleViewPaper( id,examCount){
          this.$router.push( {path: '/mini_paper', query: { id: id,examCount:examCount}})
        },

        handleCommitPaper(examId){
          let url = "/bc/exa/exam/examCommitPaper"
          let dat ={
            themeId:examId,student:true
          }
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'success',
                duration: MESSAGE_DURATION
              }) 
            }else{
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
            }) 
          })

        },

        onLoad() {
          setTimeout(()=> this.examListLoad( (this.pageNo  + 1)),200)
        },
        handleCommandExam(obj){
          let{ examId , examCount , examMaxCount} = obj
          if(examCount == 0){
            this.handleReExamPaper(examId) 
          }else{
            if(examCount == examMaxCount){
              this.handleViewPaper(examId , null)
            }else{
              this.handleViewPaper(examId , examCount)
            }
          }
        },
        handleReExamPaper(id){
          let dat = {
            themeId : id 
          }
          let url = "/bc/exa/themeUser/reExam"
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.handleViewPaper(id, null)
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch((err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
        examListLoad(pageNo){
  
          let dat = {student:true,pageNo,pageSize : 10}
          let s = JSON.stringify(dat)  
          let url = "/bc/exa/exam/selectUserExamPage"
          axios.post(url, s).then((response) => {
       
            this.pageNo = pageNo
            if (response.data.code === 0) {
              let dat = response.data.data
              if(dat.data.length !== 0){
                  if(pageNo == 1){
                    this.examList = [];
                  }
              
                  dat.data.forEach(t=>this.examList.push(t))

                  if( dat.data.length <dat.pageSize ){

                      this.finished = true;
                  }
              } else {
                this.finished = true
                if(pageNo == 1){
                  this.$message({
                    showClose: true,
                    message: '未查询到考试信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
                
              }
              this.loading = false;
            }else{
              this.finished = true
     
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
            }).catch((err)=>{
              this.pageNo = pageNo -1
              this.loading = false;
              this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            });
        },
      },
      created(){
        // setTimeout(()=>{this.examListLoad(1),200})
      },
      components:{
        mini_head_top
      }
    }
  </script>
  
  <style lang="less" scoped>
      
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_exa_list.vue